


















































































































































































// tslint:disable-next-line:no-unused
import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import MswWidgets from '@/shared/custom-component/msw-widget-card';
import { RootStoreState } from '@/store';
import { DashBoardStoreState, UpdateEventObject } from '..';
import { State, Mutation } from 'vuex-class';
// import { SetHelpContentIdPayload, SetHelpContainerSlideVisiblePayload, CoreStoreState } from '@/core/core.store';
import { CoreStoreState, SetHelpContentIdPayload } from '@/core/core.store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import DashboardListView from './msw-dashboard-list-view.vue';
import DashboardCardView from './msw-dashboard-card-view.vue';
import { currentUserKey } from '@/shared/msw-constants';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import * as jwt from 'jwt-decode';
import { TENANTS_STORE_NAME } from '@/services/indexedDb.service';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { localStorageKeeperService } from '@/shared/auth-service';
import PendoConsentdDialog from '@/shared/pendo-consent-dialog/pendo-consent-dialog.vue';
import SuperAdminModal from '@/shared/addOrUpdateSuperAdminModal/addOrUpdateSuperAdminModal.vue';
import  { MswApiService } from '@/shared/msw-api-service';
declare var gtag: Function;
// import productListCache from '@/shared/cache-api-service/endpoints/product-services-data-cache';

// declare var delighted: any;
// tslint:disable-next-line:no-unused

const cssPrefix = 'msw-dashboard';

@Component({
  components: {
    ...UUIFComponents,
    DropdownLight,
    ...MswWidgets,
    DashboardCardView,
    DashboardListView,
    SwIconButton,
    PendoConsentdDialog,
    SuperAdminModal,
  },
  directives: {
    tooltip,
  },
})
export default class MswDashboard extends SwExtendedVue{
  cssPrefix = cssPrefix;
  dashBoardSearchPlaceholder: any;
  searchedCustomer: string = '';
  productTypeOptions: SelectOption[] = [
    { id: 'edit', label: 'Edit', value: 'Edit' },
    { id: 'delete', label: 'Delete', value: 'Delete' }];
  productTypeSelectValue: string = 'Edit';
  sharedIconShowFlag :any = [];
  sharedIconShowMap : Map<number , any>;
  @State((state: RootStoreState) => state.DashBoardStoreModule.activeFilterStatus)
  activeFilterStatus: 'All'|'Starred'|'sharedToMe'|'sharedByMe';

  @State((state: RootStoreState) => state.DashBoardStoreModule.viewType)
  viewType: 'List'|'Card' ;

  @State((state: RootStoreState) => state.DashBoardStoreModule.filteredCustomers)
  customersDetails: DashBoardStoreState['filteredCustomers'];

  @State((state: RootStoreState) => state.DashBoardStoreModule.sortBy)
  selectedSortBy: 'defcon_1-5'|'defcon_5-1'|'shield_1-10'|'shield_10-1'|'customerName';

  @State((state: RootStoreState) => state.CoreStoreModule.supportCaseSliderVisible)
  createTenantVisible: CoreStoreState['supportCaseSliderVisible'];

  @State((state: RootStoreState) => state.CoreStoreModule.alertSliderVisible)
  activeAlertSlider: CoreStoreState['alertSliderVisible'];

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;
  userMessage: string = '';

  addOrUpdateSuperAdminModal: boolean = false;
  /*@Mutation
  readonly setHelpContainerSlideVisible: VuexMappedMutation<SetHelpContainerSlideVisiblePayload>;

  @State((state: RootStoreState) => state.CoreStoreModule.helpContainerSlideVisible)
  helpContainerSlideVisible: CoreStoreState['helpContainerSlideVisible'];*/

  changeRegisteredOnFilter() {
  }

  opt1 = {
    steps:[
      {
        element:'#customer0',
        intro:'View all customers and their suspicious alerts. Check the level of security by looking at defcon and shield level..',
        position:'bottom',
      },
    ],
  };
  filteredCustomers: any[] = [];
  sortOptions: any[] = [
    { id:'customerName', label: 'Customer Name', value: 'customerName' },
    { id:'defcon_1-5', label: 'Defcon 1-5', value: 'defcon_1-5' },
    { id:'defcon_5-1', label: 'Defcon 5-1', value: 'defcon_5-1' },
    { id:'shield_1-10', label: 'Shield 1-10', value: 'shield_1-10' },
    { id:'shield_10-1', label: 'Shield 10-1', value: 'shield_10-1' },
  ];
  filteredCountriesBasic: any = [];
  showPendoConsentModal: boolean = false;
  createCustomer() {
    this.$router.push({ path: '/m/feature/create-customer?redirect=true' });
    window.parent.postMessage({
      redirectUrl : '/m/feature/create-customer?redirect=true',
    },                        '*');
  }
  searchCustomer() {
    this.filteredCustomers = this.customersDetails.filter(each =>
      each.customerName.toLowerCase()
      .indexOf(this.searchedCustomer.toLowerCase()) > -1)
      .map(each => each.customerName);
    this.customersDetails.forEach((each : any, index: any) => {
      if (each.sharedGroupHoverText !== '') {
        this.sharedIconShowMap.set(index, each.sharedGroupHoverText);
      }
    });
  }
  filterCustomerByText() {
    this.$store.commit('DashBoardStoreModule/filterCustomer', { searchText: this.searchedCustomer });
    this.$store.commit('DashBoardStoreModule/sortCustomer');
  }
  // tslint:disable-next-line:no-unused
  goToProduct(selectedCustomer : any) {
    // this.$router.push({ path: `/m/feature/products?tenant=${selectedCustomer}` });
    // window.parent.postMessage({
    //   redirectUrl : `/m/feature/products?tenant=${selectedCustomer}`,
    // },                        '*');
  }

  created() {
    this.sharedIconShowMap = new Map();
    setTimeout(() => {
      if (document.getElementById('customerSearch')) {
        document.getElementById('customerSearch')!
        .focus();
      }
    },         500);
    this.dashBoardSearchPlaceholder = this.$t('workflow.dashboard.searchCustomer');
  }
  mounted() {
    const helpView = (this.viewType === 'List') ? 'dashboard' : 'dashboard_listview';
    // this.setHelpContentId({ helpId: helpView });
    this.setHelpId(helpView);
    this.searchedCustomer = this.$store.getters['DashBoardStoreModule/getSearchedCustomer'];
    console.warn(this.$store.getters.indexedDbWaitList, TENANTS_STORE_NAME);
    this.getCustomerList();
    const appName = this.$router.currentRoute.query.appName ? this.$router.currentRoute.query.appName.toString() : '';
    if (appName && appName !== '') {
      this.$store.dispatch('DashBoardStoreModule/updateAppName', appName)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp) {
          console.warn(resp);
        }
      })
      .catch((error :any) => {
        console.warn(error);
      });
    }
    this.loadScreenViewGA();
    const pendoMode = localStorageKeeperService.retrieve('showPendo') || '';
    if (pendoMode !== '' && pendoMode === 'NO_CHOICE') {
      this.showPendoConsentModal = true;
    }

    const supportData = localStorage.getItem('supportCasesData') || null;
    if (supportData === null) {
      this.getLists();
    }
    // const dta = {
    //   pageno : 1,
    //   pagesize: 10000,
    //   msspids : 'All',
    //   tenantids : 'All',
    //   serialNumber : '',
    //   productLine: '',
    //   friendlyName : '',
    //   firmwareVersion: '' ,
    //   isForced : 'YES',
    // };
    // if (JSON.parse(localStorage.getItem(currentUserKey) as any).roles
    // .includes('MSSPPAYGO')) {
    //   productListCache.getproductListsData(dta, false)
    //     // MswApiService.tenant.getMsspProductDetails(dta)
    //     .then(() => {
    //     })
    //     .catch(() => {
    //     });
    // }
  }

  loadScreenViewGA() {
    const currentUserT: string = localStorage.getItem(currentUserKey) || '';
    const token = currentUserT && JSON.parse(currentUserT) ? JSON.parse(currentUserT).token : '';
    // tslint:disable
    gtag('set', { 'user_id': (jwt(token) as any).userName });
    gtag('event', 'screen_view', {
      'partner_tier': (jwt(token) as any).partnerTier || 'NA',
      'company_name': (jwt(token) as any).companyName || 'NA',
      'country_code': (jwt(token) as any).countryCode || 'NA',
      'username': (jwt(token) as any).userName || 'NA',
    });
    // tslint:enable
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
    window.parent.postMessage({ route: 'dashboard', helpId: temp }, '*');
  }
  updated() {
    const helpView = this.viewType === 'List' ? 'dashboard' : 'dashboard_listview';
    // this.setHelpContentId({ helpId: helpView });
    this.setHelpId(helpView);
  }
  destroyed() {
    // this.setHelpContentId({ helpId:'default' });
    this.setHelpId('default');
    window.parent.removeEventListener('storage', () => {});
  }
  changeView() {
    if (this.viewType === 'Card') {
      this.$store.commit('DashBoardStoreModule/switchCssView', { value: true });
      this.$store.commit('DashBoardStoreModule/mutate', { property: 'viewType', with: 'List' });
      return;
    }
    this.$store.commit('DashBoardStoreModule/switchCssView', { value: false });
    this.$store.commit('DashBoardStoreModule/mutate', { property: 'viewType', with: 'Card' });
  }
  sortCustomer(seletedSortBy: string) {
    this.$store.commit('DashBoardStoreModule/sortCustomer', seletedSortBy);
  }

  updateFilterStatus(status: string) {
    this.$store.commit('DashBoardStoreModule/filterCustomer', { filterBy: status });
    this.$store.commit('DashBoardStoreModule/sortCustomer');
  }
  getCustomerList(isUpdate = false, forceFetch = false) {
    this.$store.commit('startLoading');
    this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', forceFetch)
    .then((response: any) => {
      // Store response in store for products management widget to use
      const prodMgtmWidgetDetails = {
        customersCount : response['customersCount'],
        productsCount  : response['productsCount'],
        totSoonExpiringProducts : response['totSoonExpiringProducts'],
        totExpiredProducts : response['totExpiredProducts'],
      };
      if (prodMgtmWidgetDetails.customersCount > 10 && !isUpdate) {
        this.$store.commit('DashBoardStoreModule/mutate', { property: 'viewType', with: 'Card' });
      }
      this.$store.commit('DashBoardStoreModule/updateProductmgmtWidgetInfo', prodMgtmWidgetDetails);
      this.$store.commit('stopLoading');
      let content: any[] = [];
      const responseT = response['prodGroupLicenseStatus'];
      if (responseT) {
        responseT.forEach((resp: any) => {
          content.push({
            customerId: resp.productGroupId,
            customerName: resp.productGroupName,
            shield: Number(resp.shieldLevelValue) || 0,
            defCon: Number(resp.defconValue) || 0,
            firewall: Number(resp.firewallCount) || 0,
            accessPoint: Number(resp.accessPointsCount) || 0,
            endpoints: Number(resp.endPointsCount) || 0,
            cloudUsers: resp.cloudUsersCount,
            licenceStatus: '',
            isStarred: resp.isStarred,
            downloadsAvailable: Number(resp.downloadsAvailableCount) || 0,
            canDelete: resp.showDeleteLink,
            canRename: resp.showRenameLink,
            isDefault: resp.isDefaultGroup,
            soonExpiringProducts: resp.soonExpiringProducts,
            expiredProducts: resp.expiredProducts,
            activeProducts: resp.activeProducts,
            isDefaultGroup: resp.isDefaultGroup,
            isSharedGroup: resp.isSharedProductGroup === 'YES',
            isEnableStarred: resp.isEnableStarred,
            isSharedProductGroup: resp.isSharedProductGroup,
            sharedGroupHoverText: resp.sharedGroupHoverText,
            showDefault: resp.showDefault,
          });
        });
        content = [
          ...content.filter((each: any) => each.isDefault === 'TRUE'),
          ...content
            .filter((each: any) => each.isDefault === 'FALSE' && each.isStarred)
            .sort((a: any, b: any) => a.customerName.toLowerCase() < b.customerName.toLowerCase() ? -1 : 1),
          ...content
          .filter((each: any) => each.isDefault === 'FALSE' && !each.isStarred)
          .sort((a: any, b: any) => a.customerName.toLowerCase() < b.customerName.toLowerCase() ? -1 : 1)];
        this.$store.commit('DashBoardStoreModule/updateWidgetInfo', content);
        if (isUpdate) {
          this.updateFilterStatus(this.activeFilterStatus);
        }
      } else if (response.userMessage.indexOf('access') > -1) {
        this.userMessage = response.userMessage;
      }
    });
  }

  handleUpdate(data: UpdateEventObject) {
    if (this.$store.getters.isLargeCustomer && (data.edit || data.delete || data.starred || data.default)) {
      this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets')
      .then((response: any) => {
        const customerDataList = response['prodGroupLicenseStatus'];
        if (data.edit) {
          // @ts-ignore
          const index = customerDataList.findIndex((item: any) => { return item.productGroupId === data.edit.customerId; });
          if (index > -1) {
            customerDataList[index].productGroupName = data.edit.newName;
          }
        } else if (data.delete) {
          // @ts-ignore
          const index = customerDataList.findIndex((item: any) => { return item.productGroupId === data.delete.customerId; });
          if (index > -1) {
            customerDataList.splice(index, 1);
          }
        } else if (data.starred) {
          // @ts-ignore
          const index = customerDataList.findIndex((item: any) => { return item.productGroupId === data.starred.customerId; });
          if (index > -1) {
            customerDataList[index].isStarred = data.starred.enable;
          }
        } else if (data.default) {
          // @ts-ignore
          const newTenantIndex = customerDataList.findIndex((item: any) => { return item.productGroupId === data.default.customerId; });
          // @ts-ignore
          const oldTenantIndex = customerDataList.findIndex((item: any) => { return item.isDefaultGroup.toLowerCase() === 'true'; });
          if (newTenantIndex > -1 && oldTenantIndex > -1) {
            const isDefaultGroupValue = customerDataList[newTenantIndex].isDefaultGroup;
            const showDefaultValue = customerDataList[newTenantIndex].showDefault;
            customerDataList[newTenantIndex].isDefaultGroup = customerDataList[oldTenantIndex].isDefaultGroup;
            customerDataList[newTenantIndex].showDefault = customerDataList[oldTenantIndex].showDefault;
            customerDataList[oldTenantIndex].isDefaultGroup = isDefaultGroupValue;
            customerDataList[oldTenantIndex].showDefault = showDefaultValue;
          }
        }
        response['prodGroupLicenseStatus'] = customerDataList;
        this.$store.dispatch('DashBoardStoreModule/saveCustomerWidgets', response)
        .then(() => {
          this.getCustomerList(true);
        });
      });
    } else {
      this.getCustomerList(true);
    }
  }
  getShowSharedIconFlag(customer : any) {
    return this.sharedIconShowMap.get(customer.index);
  }
  async closePendoConsentdDialog(dialogResp: boolean) {
    this.showPendoConsentModal = false;
    if (dialogResp) {
      localStorageKeeperService.save('showPendo', 'YES');
    }
  }

  getLists() {
    this.$store.commit('startLoading');

    const adminListPromise = this.$store.dispatch('AccessManagementStoreModule/getAdminList')
    .then((res: any) => {
      if (res?.operationStatus === 'OK') {
        this.$store.commit('AccessManagementStoreModule/setAdminList', res?.adminList || []);
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res?.msgDesc });
      }
    })
    .catch(() => {
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Failed to fetch admin list' });
    });

    const userListPromise = this.$store.dispatch('SnbProfileStoreModule/getUserList', 'NO')
    .then((res: any) => {
      if (res?.operationStatus === 'OK') {
        this.$store.commit('AccessManagementStoreModule/setMaxSuperAdminCount', res?.content?.maxSuperAdminCount);
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res?.msgDesc });
      }
    })
    .catch(() => {
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Failed to fetch user list' });
    });
    Promise.all([adminListPromise, userListPromise])
    .finally(() => {
      MswApiService.widgetsInfo.getSupportCases()
      .then((response: any) => {
        localStorage.setItem('supportCasesData', JSON.stringify(response));
        if (response.msgCode === 'SUCCESS') {
          if (response.isAssignSuperAdmin === 'YES') {
            this.addOrUpdateSuperAdminModal = true;
          }
        }
      })
      .catch((err: any) => {
        console.error(err);
      });
      this.$store.commit('stopLoading');
    });
  }

  closeAddOrUpdateSuperAdminModal() {
    this.addOrUpdateSuperAdminModal = false;
  }
}
